import React from 'react';
import Select from 'four-nets/ui-v2/select/select';
import {FormattedMessage} from 'react-intl';
import { ProjectSelectFragment } from './project-select.graphql';

export type Props = React.SelectHTMLAttributes<HTMLSelectElement> & ProjectSelectFragment;

class ProjectSelect extends React.PureComponent<Props> {
    render() {
        const {edges, ...rest} = this.props;

        if (!edges.length) {
            return null;
        }

        return (
            <Select {...rest}>
                <FormattedMessage id='ALL_PROJECTS'>{message => <option value=''>{message}</option>}</FormattedMessage>}
                {edges.map((edge) => {
                    if (edge && edge.node) {
                        const {project, id} = edge.node;
                        return <option key={id} value={id}>{project}</option>;
                    }
                    return null;
                })}
            </Select>
        );
    }
}

export default ProjectSelect;
